'use client';

var translations = {
    'Report company': 'Báo cáo công ty',
    'VietnamWorks has received the report. VietnamWorks is checking and working with the company. And we will reply to you as soon as possible.': 'VietnamWorks đã tiếp nhận báo cáo. VietnamWorks đang kiểm tra và làm việc với công ty. Và chúng tôi sẽ hồi âm bạn trong thời gian sớm nhất.',
    'Reported this company': 'Đã báo cáo công ty này',
    Send: 'Gửi',
    'Please input detail description.': 'Bạn cần nhập mô tả chi tiết.',
    'Your comments make an important contribution to protecting the Company Seeker Community.': 'Ý kiến đóng góp của bạn sẽ góp phần quan trọng để bảo vệ cộng đồng người tìm việc',
    'Report a company successfully': 'Báo cáo công ty thành công',
    'Scam detection': 'Nhận diện một số hình thức lừa đảo',
    'View detail': 'Xem chi tiết',
    Close: 'Đóng',
    "Can't update this Report Company": 'Không thể cập nhật báo cáo công ty này',
    'Report Company error': 'Lỗi báo cáo công ty',
    'Details of the reason.': 'Mô tả chi tiết lý do báo cáo.',
    login: 'dang-nhap'
};

export { translations as default };
//# sourceMappingURL=translation.js.map
